import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-0"}],["path",{"d":"M9 10h6","key":"svg-1"}],["path",{"d":"M9 16h6","key":"svg-2"}],["path",{"d":"M12 7v6","key":"svg-3"}]]

const IconCirclePlusMinus = createReactComponent('outline', 'circle-plus-minus', 'CirclePlusMinus', __iconNode);

export default IconCirclePlusMinus;